/* global AUTHORIZATION */

import axios from 'axios'
import { Capacitor } from '@capacitor/core'

export const getApiBaseUrl = () => {
  if (Capacitor.isNativePlatform()) {
    // PRODUCTION (Live Server for Mobile App)
    return 'https://pracxel-backend-api-312024629938.asia-south1.run.app/';
  }

  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.') || host.startsWith('10.') || window.location.protocol === 'http:';

  if (!isLocal) {
    // PRODUCTION (Live Server for Web App)
    return 'https://pracxel-backend-api-312024629938.asia-south1.run.app/';
  }

  // LOCAL DEVELOPMENT (Laptop Browser)
  return 'http://127.0.0.1:7445/';
}


axios.defaults.baseURL = getApiBaseUrl()
axios.defaults.headers = {
  'Content-Type': 'application/json',
}

// Add request interceptor to inject tenant slug
axios.interceptors.request.use(
  config => {
    const host = window.location.hostname;
    if (host) {
      config.headers['X-Forwarded-Host'] = host;
    }
    const rawToken = localStorage.getItem('accessToken') || localStorage.getItem('token');
    if (rawToken && !config.headers['x-auth']) {
      try {
        const token = rawToken.startsWith('"') ? JSON.parse(rawToken) : rawToken;
        config.headers['x-auth'] = token;
      } catch (e) {
        config.headers['x-auth'] = rawToken;
      }
    }
    // Regex to detect IP addresses
    const isIP = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(host);
    const tenantSlug = localStorage.getItem('tenant_slug');

    if (tenantSlug) {
      config.headers['X-Tenant-Slug'] = tenantSlug;
    } else {
      // Check if it's not an IP and has a subdomain (more than 2 parts, e.g., slug.domain.com)
      // Also handling localhost for testing if needed, though usually localhost doesn't have subdomains unless configured in hosts
      const parts = host.split('.');

      if (!isIP && parts.length > 2) {
        const subdomain = parts[0];
        // Exclude common non-tenant subdomains
        if (
          subdomain !== 'www' &&
          subdomain !== 'backend' &&
          subdomain !== 'automation' &&
          subdomain !== 'pracxel-backend-api-312024629938' &&
          !host.endsWith('.run.app')
        ) {
          config.headers['X-Tenant-Slug'] = subdomain;
        }
      }
    }
    return config;
  },
  error => Promise.reject(error)
);